import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getCCFFiltersAPI } from "../../apiConfig/apiCall";

export const getCCFFilterList = createAsyncThunk('getCCFFilterList', async () => {
    const response = await getCCFFiltersAPI();
    return response.data;
});

const getCCFFilterListSlice = createSlice({
    name: "getCCFFilterList",
    initialState: {
        isLoading: false,
        isError: false,
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(getCCFFilterList.pending, (state) => {
            state.isLoading = true;
            state.isError = false;
        });
        builder.addCase(getCCFFilterList.fulfilled, (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
        });
        builder.addCase(getCCFFilterList.rejected, (state) => {
            state.isError = true;
            state.isLoading = false;
        });
    }
});

export default getCCFFilterListSlice.reducer;